
import React from 'react';
import { lazy } from 'react';

// Lazy load pages to improve performance
const Home = lazy(() => import('../pages/Index'));
const Companies = lazy(() => import('../pages/Companies'));
const CompanyDetail = lazy(() => import('../pages/CompanyDetail'));
const CompanyReviews = lazy(() => import('../pages/company/CompanyReviews'));
const CompanySalaries = lazy(() => import('../pages/company/CompanySalaries'));
const CompanyInterviews = lazy(() => import('../pages/company/CompanyInterviews'));
const CompanyJobs = lazy(() => import('../pages/company/CompanyJobs'));
const Jobs = lazy(() => import('../pages/Jobs'));
const JobDetails = lazy(() => import('../pages/JobDetails'));
const JobDetailsByFilter = lazy(() => import('../pages/JobDetailsByFilter'));
const Reviews = lazy(() => import('../pages/Reviews'));
const ReviewDetail = lazy(() => import('../pages/ReviewDetail'));
const ReviewsByCompanyAndRole = lazy(() => import('../pages/aggregated/ReviewsByCompanyAndRole'));
const Salaries = lazy(() => import('../pages/Salaries'));
const SalariesByLocation = lazy(() => import('../pages/aggregated/SalariesByLocation'));
const TopCompaniesByLocation = lazy(() => import('../pages/aggregated/TopCompaniesByLocation'));
const SubmitSalary = lazy(() => import('../pages/SubmitSalary'));
const SubmitReview = lazy(() => import('../pages/SubmitReview'));
const CreateCompany = lazy(() => import('../pages/companies/CreateCompany'));
const Login = lazy(() => import('../pages/Login'));
const Register = lazy(() => import('../pages/Register'));
const ResetPassword = lazy(() => import('../pages/ResetPassword'));
const ForgotPassword = lazy(() => import('../pages/ForgotPassword'));
const AdminDashboard = lazy(() => import('../pages/AdminDashboard'));
const AdminLogin = lazy(() => import('../pages/AdminLogin'));
const AdminManagement = lazy(() => import('../pages/admin/AdminManagement'));
const CompaniesManagement = lazy(() => import('../pages/admin/CompaniesManagement'));
const JobsManagement = lazy(() => import('../pages/admin/JobsManagement'));
const SalariesManagement = lazy(() => import('../pages/admin/SalariesManagement'));
const EmailManagement = lazy(() => import('../pages/admin/EmailManagement'));
const UserProfile = lazy(() => import('../pages/UserProfile'));
const UserSettings = lazy(() => import('../pages/UserSettings'));
const Community = lazy(() => import('../pages/Community'));
const Analytics = lazy(() => import('../pages/Analytics'));
const FAQ = lazy(() => import('../pages/FAQ'));
const AboutUs = lazy(() => import('../pages/AboutUs'));
const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'));
const TermsOfUse = lazy(() => import('../pages/TermsOfUse'));
const CommunityGuidelines = lazy(() => import('../pages/CommunityGuidelines'));
const TopCompanies = lazy(() => import('../pages/TopCompanies'));
const CompanyCategories = lazy(() => import('../pages/CompanyCategories'));
const CategoryDetail = lazy(() => import('../pages/CategoryDetail'));
const SalaryCalculator = lazy(() => import('../pages/SalaryCalculator'));
const CompanyDashboard = lazy(() => import('../pages/CompanyDashboard'));
const NotFound = lazy(() => import('../pages/NotFound'));
// Add QA Testing page
const QATesting = lazy(() => import('../pages/QATesting'));
const Search = lazy(() => import('../pages/Search'));

export {
  Home,
  Companies,
  CompanyDetail,
  CompanyReviews,
  CompanySalaries,
  CompanyInterviews,
  CompanyJobs,
  Jobs,
  JobDetails,
  JobDetailsByFilter,
  Reviews,
  ReviewDetail,
  ReviewsByCompanyAndRole,
  Salaries,
  SalariesByLocation,
  TopCompaniesByLocation,
  SubmitSalary,
  SubmitReview,
  CreateCompany,
  Login,
  Register,
  ResetPassword,
  ForgotPassword,
  AdminDashboard,
  AdminLogin,
  AdminManagement,
  CompaniesManagement,
  JobsManagement,
  SalariesManagement,
  EmailManagement,
  UserProfile,
  UserSettings,
  Community,
  Analytics,
  FAQ,
  AboutUs,
  PrivacyPolicy,
  TermsOfUse,
  CommunityGuidelines,
  TopCompanies,
  CompanyCategories,
  CategoryDetail,
  SalaryCalculator,
  CompanyDashboard,
  QATesting,
  Search,
  NotFound,
};
